import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
// import { LmsBookAPIServiceV1 } from '@protos/learning_management/lms.book.apis_connect';

import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';
import { LmsAssessmentTeacherAPIServiceV2 } from '@protos/learning_management/lms.assessment.teacher.apis_connect';

// export const LmsBookAPIServiceV1Client = createPromiseClient(
//   LmsAssessmentTeacherAPIServiceV1,
//   lmsTransport
// );

export const useLmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsAssessmentTeacherAPIServiceV2,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
